import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../../../redux/configureStore';
import {
  displayFaresAppDashboard,
  getBoletoFares,
  getCartaoFares,
  getCriptoFares,
  getDomicilioFares,
  getIncomeFares,
  getMonthlyFares,
  getPixFares,
  getSlbFares,
  getTedFares,
  getTevFares,
  getTibFares,
} from '../../../../../../redux/fetchActions/legadoPage/faresApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetAccountType from './components/SetAccountType';
import SetFare from './components/SetFare';
import SetFinalDate from './components/SetFinalDate';
import SetInitialDate from './components/SetInitialDate';
import SetPartner from './components/SetPartner';

export function FaresFilter() {
  const dispatch = useDispatch();

  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );

  const profileNivelState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );

  function checkNivel(props: any) {
    if (profileNivelState.nivel === 2) {
      return props;
    }
    return profileNivelState.idLegado;
  }

  function dispatchData() {
    switch (faresFilterState.fare) {
      case 'receita':
        dispatch(
          getIncomeFares({
            partner: checkNivel(faresFilterState.partner),
            accountType: faresFilterState.account,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'boleto':
        dispatch(
          getBoletoFares({
            partner: checkNivel(faresFilterState.partner),
            accountType: faresFilterState.account,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'mensalidade':
        dispatch(
          getMonthlyFares({
            partner: checkNivel(faresFilterState.partner),
            accountType: faresFilterState.account,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'ted':
        dispatch(
          getTedFares({
            partner: checkNivel(faresFilterState.partner),
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'tib':
        dispatch(
          getTibFares({
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'pix':
        dispatch(
          getPixFares({
            partner: faresFilterState.partner,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'slb':
        dispatch(
          getSlbFares({
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'cripto':
        dispatch(
          getCriptoFares({
            partner: faresFilterState.partner,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'cartao':
        dispatch(
          getCartaoFares({
            partner: faresFilterState.partner,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      case 'domicilio':
        dispatch(
          getDomicilioFares({
            partner: faresFilterState.partner,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;
      case 'tev':
        dispatch(
          getTevFares({
            partner: faresFilterState.partner,
            initialDate: faresFilterState.initialDate,
            finalDate: faresFilterState.finalDate,
          })
        );
        break;

      default:
        break;
    }

    dispatch(
      displayFaresAppDashboard(
        faresFilterState.fare,
        faresFilterState.partner,
        faresFilterState.account,
        faresFilterState.initialDate,
        faresFilterState.finalDate
      )
    );
  }

  function searchFare() {
    if (
      moment(faresFilterState.initialDate) > moment(faresFilterState.finalDate)
    ) {
      return Swal.fire({
        icon: 'error',
        title: 'A data inicial não pode ser maior que a data final!',
        confirmButtonText: 'Tentar novamente',
      });
    }
    dispatchData();
    return null;
  }

  return (
    <Filter.Default>
      <SetPartner />
      <SetFare />
      <SetAccountType />
      <SetInitialDate />
      <SetFinalDate />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default FaresFilter;
